import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { FaRegCheckCircle } from "react-icons/fa";
import { IoWarning } from "react-icons/io5";

import "../assest/Toast.css";

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="assertive" aria-atomic="true">
      {type === "success" ? <FaRegCheckCircle /> : <IoWarning />}
      <div className="toast-message">{message}</div>
      <button onClick={onClose} className="toast-close" aria-label="Close">
        <IoMdClose />
      </button>
    </div>
  );
};

export default Toast;